import React from 'react';
import { Flex, Image, Text } from 'rebass';
import DropDown, { SelectDropDownItem } from 'components/DropDown';
import arrow from 'assets/icons/arrow.png';
import styled from 'styled-components';

export interface JobSortingDropDownProps {
  isDropDownVisible: boolean;
  openDropDown: VoidFunction;
  closeDropDown: VoidFunction;
  onChange: (value: string) => void;
  values: string[];
  currentValue: string;
  title: string;
  contentStyle?: any;
  buttonStyle?: any;
}

const DropDownButton = styled(Flex)`
  :hover {
    cursor: pointer;
  }
`;

const JobSortingDropDown: React.FC<JobSortingDropDownProps> = ({
  isDropDownVisible,
  openDropDown,
  closeDropDown,
  onChange,
  values,
  currentValue,
  title,
  contentStyle,
  buttonStyle,
}): JSX.Element => {
  return (
    <Flex css="position: relative">
      <DropDownButton alignItems="center" onClick={openDropDown} style={buttonStyle}>
        <Text fontSize="18px" fontWeight={5}>
          {title}
        </Text>
        <Image src={arrow} ml={1} />
      </DropDownButton>
      <DropDown
        visible={isDropDownVisible}
        onClose={() => isDropDownVisible && closeDropDown()}
        contentStyle={contentStyle}
      >
        {values.map(value => (
          <SelectDropDownItem
            key={value}
            name={value}
            checked={value === currentValue}
            onChange={() => {
              closeDropDown();
              onChange(value);
            }}
          />
        ))}
      </DropDown>
    </Flex>
  );
};

export default JobSortingDropDown;
